import { render, staticRenderFns } from "./Controversy.vue?vue&type=template&id=af063cb0&"
import script from "./Controversy.vue?vue&type=script&lang=js&"
export * from "./Controversy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports